import React from "react";
import { Row, Col } from 'react-bootstrap';
import SectionContainer from '../components/containers/section-container';
import CoverHeaderXs from '../components/header/cover-header-xs';
import AsideElement from '../components/aside/aside';
import ArticleBlockEntry from '../components/aside/articleblockentry';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import ScrollableAnchor from 'react-scrollable-anchor'

import { FacebookButton, TwitterTweetButton } from 'react-social-sharebuttons';
import ReactGA from 'react-ga';

export const initGA = () => {
    /* console.log('Ga init'); */
     ReactGA.initialize('UA-90162173-1'); 
}

export const logPageView = () => {
    /* console.log(window.location.pathname); */
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
}

const recentPosts = 'Recent_Posts';

const headerSizeClass = ['gtco-cover-xs'];


class ArticlePage extends React.Component {
    componentDidMount() {
        initGA();
        logPageView();
    }
    render() {
        var shareUrl = 'http://www.bttsd.com/'+ this.props.location.pathname + this.props.location.hash;

        var location = this.props.location.hash;
        var blogEntries = this.props.blogEntries;
        const entry = Object.keys(this.props.blogEntries).map(function(keyName, keyIndex) {

            var articleLink = "#"+blogEntries[keyName].link_to_article;
            if(location === articleLink) {
                return (
                    <span key={ keyIndex }>
                        <ScrollableAnchor id={blogEntries[keyName].link_to_article}>
                            <CoverHeaderXs backgroundImage={ blogEntries[keyName].article_image } headerSizeClass={ headerSizeClass } headerTitle={ blogEntries[keyName].title } />
                        </ScrollableAnchor>
                        <div className="gtco-section blog">
                            <SectionContainer>
                                <Row>
                                    <ArticleBlockEntry content={ blogEntries[keyName] } />
                                    <Col md={4}>
                                        <AsideElement recentPosts={ recentPosts } content={ blogEntries } activeElement={ blogEntries[keyName].title } />
                                        <div className="social">
                                            <span className="social-title">Social:</span>
                                            <FacebookButton url={shareUrl} showFaces={false} share layout='button' />
                                            <TwitterTweetButton url={shareUrl}  />
                                        </div>
                                    </Col>
                                </Row>
                            </SectionContainer>
                        </div>
                    </span>
                )
            }else{
                return false
            }
        });
        return (
            <div id="page">
                {entry}   
             </div>                     
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(ArticlePage);


// WEBPACK FOOTER //
// ./src/pages/article-page.js